<script>
import { tweened } from 'svelte/motion';
import { cubicOut } from 'svelte/easing';
import { onMount } from 'svelte'

export let w
export let h
export let lineWidth
export let label = ""
export let porc = 0

let val = 30
let canvas

const porcentaje = tweened(1, {
    duration: 500,
    easing: cubicOut
});

$: label && Draw($porcentaje, w,h)

const Draw = (porcentaje, w,h) => {
    try {
        var ctx = canvas.getContext("2d")
        let d1 =  (2*Math.PI*porcentaje)/100
        ctx.reset()
        ctx.lineWidth = lineWidth
        ctx.beginPath();
        ctx.strokeStyle  = '#efefef';
        ctx.arc(w/2,h/2, (w/2) - lineWidth/2,0, Math.PI*2, false) // x, y, radius, start angle, end angle, false/true
        ctx.stroke()
        ctx.beginPath();
        ctx.strokeStyle  = '#e74c3c';
        ctx.arc(w/2,h/2, (w/2) - lineWidth/2,0, d1, false) // x, y, radius, start angle, end angle, false/true
        ctx.stroke()
        ctx.closePath();

        // Test
        ctx.restore();
        var fontSize = parseInt((h*0.20).toFixed(2));
        // ctx.font = fontSize + "px Verdana";
        ctx.font=`bold ${fontSize}px Roboto`;
        ctx.textBaseline = "middle";
        console.log(w )
 
        var text = `${parseInt(porcentaje)}%`
        var textX = Math.round((w - ctx.measureText(text).width) / 2)
        var textY = (h / 2) //+  chart.legend.height + chart.titleBlock.height;
        textY =  (h / 2) - (fontSize*0.08)

        var textLabel = `${label}`
        var labelX = Math.round((w - ctx.measureText(textLabel).width) )
        var labelY =  (h / 2) + (fontSize / 2)

        // write Porcentaje
        ctx.fillStyle = "#34495e99"
        ctx.fillText(text, textX, textY);

        // write Label
        fontSize = parseInt((h*0.10).toFixed(2));
        ctx.font=`bold ${fontSize}px Roboto`;
        var lx = (w - ctx.measureText(textLabel).width)/2
        console.log(w , ctx.measureText(textLabel).width, w - ctx.measureText(textLabel).width, lx)

        ctx.fillText(textLabel, lx, labelY);

        // ctx.save();
    }catch(err){

    }
}

onMount(async () => {
    porcentaje.set(porc);
});

</script>

<div class="canvas-container" style="width: {w}px;">
    <canvas bind:this={canvas} id="myCanvas" width={w} height={h}></canvas>
    <!-- <div class="label-percent">{parseInt($porcentaje)}%</div> -->
    <!-- <span class="label-2">{label}</span> -->
    <slot></slot>
</div>

<style>
    .canvas-container {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        line-height: 1;
        color: #8b959a;
    }

    #myCanvas {
        z-index: 0;
        position: absolute;
        top:0;
        left:0;
    }

    .label-percent {
        font-size: 2.5em;
        font-weight: bold;

    }

    .label-2 {
        font-weight: bold;
    }
</style>